import styled from '@emotion/styled'
import { WORKFLOW_FIELD_TYPE_DATETIME } from 'Constants/'
import {
  Flex,
  FlexItem,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputNumber
} from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useState } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const StyledInlineLabel = styled.label`
  font-weight: 400;
  cursor: pointer;
`

const InputIdFieldFilterDatetime = () => {
  const intl = useIntl()
  const { FieldType, FieldValue } = useRecoilValue(step2State)

  const [hoursAfter, setHoursAfter] = useState(
    FieldType === WORKFLOW_FIELD_TYPE_DATETIME ? parseInt(FieldValue) : 1
  )

  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const handleHoursAfterChange = (value) => {
    setHoursAfter(value)
    setWorkflowDetailsState((prev) => ({ ...prev, FieldValue: `${value}` }))
  }

  const wrongFormatFeedback = intl.formatMessage(
    {
      id: 'Load.AutomationWorkflow.LastDayValidation'
    },
    {
      XGIORNI: 9999
    }
  )

  const hoursAfterIsValid =
    hoursAfter !== null && hoursAfter >= 0 && hoursAfter <= 9999

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.EventTimeTile'
      })}
      required
    >
      <Flex margin='24px 0'>
        <FormElement
          feedback={!hoursAfterIsValid ? wrongFormatFeedback : undefined}
          feedbackVariant={!hoursAfterIsValid ? 'danger' : undefined}
        >
          <Flex alignItems='flex-start'>
            <Flex display='block' width='85px' flexGrow='0' margin='0 16px 0 0'>
              <InputNumber
                value={hoursAfter}
                onChange={handleHoursAfterChange}
                min={0}
                max={9999}
                step={1}
                maxLength={4}
                variant={
                  !hoursAfterIsValid ? INPUT_TEXT_VARIANT_DANGER : undefined
                }
              />
            </Flex>
            <FlexItem margin='8px 0 0 0'>
              <StyledInlineLabel>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.EventTimeHoursAfter'
                })}
              </StyledInlineLabel>
            </FlexItem>
          </Flex>
        </FormElement>
      </Flex>
    </FormElement>
  )
}

export default InputIdFieldFilterDatetime
